"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGitful = exports.GITFUL_REQUIRED_FIELDS = void 0;
/**
 * The fields that must be provided together for a session to be "gitful":
 * `git_url`, `git_branch` and `git_commit_sha`.
 *
 * Why these three, and not `git_commit_author` / `git_commit_email` /
 * `git_commit_message` / `git_tag`? Only the triple makes a session addressable
 * in the branch and commit views. The rest is independent, optional context:
 * persisted when supplied, never gating. (`git_default_branch` is not in that
 * group — it presumes a gitful context, so ingestion drops it when the triple
 * is incomplete; see `normalizeGitInfo` in axe-result.)
 */
exports.GITFUL_REQUIRED_FIELDS = [
    'git_url',
    'git_branch',
    'git_commit_sha'
];
const isPresent = (value) => typeof value === 'string' && value !== '';
/**
 * Whether git information is complete enough to be treated as gitful.
 *
 * This is the single application-layer definition of the git/gitless boundary.
 * The persistence layer defines it separately — axe-result's `*gitful*.sql`
 * queries and the `sessions` partial indexes key on `IS NOT NULL` — and is
 * deliberately out of scope here; the two agree because `normalizeGitInfo`
 * coerces a blank value to `null` before it is persisted.
 *
 * Deliberately structural rather than tied to a session type, so it serves a
 * persisted session, an incoming ingestion payload, or any other carrier of the
 * triple — narrowing each to its own gitful form.
 *
 * @example
 * isGitful({ git_url: 'u', git_branch: 'b', git_commit_sha: 's' }); // => true
 * @example
 * // a partial triple is gitless, even alongside other git metadata
 * isGitful({ git_url: 'u', git_branch: null, git_commit_sha: 's' }); // => false
 */
const isGitful = (info) => !!info && exports.GITFUL_REQUIRED_FIELDS.every(field => isPresent(info[field]));
exports.isGitful = isGitful;
//# sourceMappingURL=gitful.js.map